import { getFeatureToggleClient } from 'misc/featureToggles'

export default function isDocumentRequestFlowEnabled() {
  return getFeatureToggleClient().variation(
    'Portals.DocumentRequestFlow',
    false
  )
}
